<template>
  <div ref="lottieContainer" class="lottie-container" :class="{'relative' : relative}"></div>
</template>

<script>
  import lottie from 'lottie-web';

  export default {
    data() {
      return {
        lottieContainer: null,
        animationInstance: null,
      }
    },

    props: {
      animation: {
        type: String,
        default: null
      },

      relative: {
        type: Boolean,
        default: false
      },

      speed: {
        type: Number,
        default: 1
      },

      autoplay: {
        type: Boolean,
        default: false
      },

      delay: {
        type: Number,
        default: 0,
      },

      reverseDelay: {
        type: Number,
        default: 0,
      },

      reverse: {
        type: Boolean,
        default: false
      },
    },

    mounted () {
      this.initLottie();
    },

    methods: {
      initLottie() {
        this.lottieContainer = this.$refs.lottieContainer;

        if (this.lottieContainer) {
          this.animationInstance = lottie.loadAnimation({
            container: this.lottieContainer,
            animationData: require(`@/assets/lottie/${this.animation}.json`),
            renderer: 'svg',
            loop: false,
            autoplay: false,
          });
        }

        if (this.autoplay) {
          setTimeout(() => {
            this.play();
          }, this.delay)
        }

        if (this.reverse) {
          setTimeout(() => {
            this.reverseAnimation();
          }, this.reverseDelay)
        }
      },

      play() {
        if (this.animationInstance) {
          this.animationInstance.setSpeed(this.speed)
          this.animationInstance.goToAndPlay(0, true);
        }
      },

      reverseAnimation() {
        if (this.animationInstance) {
          this.animationInstance.setSpeed(this.speed)
          this.animationInstance.setDirection(-1);
          this.animationInstance.play();
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .lottie-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 75vh;
    z-index: 10;
    pointer-events: none;

    &.relative {
      position: relative;
      height: auto;
      width: auto;
    }
  }
</style>